(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-accordion]').forEach(function (item) {
    var btn = item.querySelector('.accordion-header');
    var body = item.querySelector('.accordion-body');

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        body.style.height = body.scrollHeight + 'px';
        body.offsetHeight;
        body.classList.add('is-animating');
        body.style.transition = 'height 0.3s ease';
        body.style.height = '0';
        body.addEventListener('transitionend', function handler() {
          body.removeAttribute('style');
          body.classList.remove('is-animating');
          body.setAttribute('hidden', '');
          body.removeEventListener('transitionend', handler);
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.removeAttribute('hidden');
        body.classList.add('is-animating');
        var h = body.scrollHeight;
        body.style.height = '0';
        body.style.overflow = 'hidden';
        body.style.transition = 'height 0.3s ease';
        body.offsetHeight;
        body.style.height = h + 'px';
        body.addEventListener('transitionend', function handler() {
          body.removeAttribute('style');
          body.classList.remove('is-animating');
          body.removeEventListener('transitionend', handler);
        });
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
